/*
 * 大于2次以上的接口调用，封装到此文件
 * */
import request from '@/utils/request'
import config from '@/config'

// 获取图片验证码
export const getImgCaptcha = date =>
  `${config.baseApi}/masterdata-api/captcha?_=${date}`

// 获取 City、Country、Region、Business、CCA、Document Type、File Language， 参数 typeMark 传以上字段
export const getSelectList = params => {
  if (typeof params === 'string') params = { typeMark: params }
  return request.post('/masterdata-api/valuelist/getValueList', params)
}
// 统一上传地址
export const commonUploadUrl = `${config.baseApi}/customer-api/customer/attachment/upload`

// 统一下载
export const commonDownload = id =>
  request.get(
    `/customer-api/customer/attachment/download/${id}`,
    {},
    { responseType: 'blob' },
  )
// 统一删除
export const commonRemoveFile = id =>
  request.get(`/customer-api/customer/attachment/delete/file/${id}`)

export const commonUpload = params =>
  request.post('/customer-api/customer/attachment/upload', params)

// 获取 currency list
export const getCurrencyList = () => request.get('/masterdata-api/rate/list')
